import { put } from 'redux-saga/effects';
import { change } from 'redux-form';

export function* updateReferenceCode(newCode: string) {
  yield put(change('creditInfo', 'referenceCode', newCode));
}
